import { AppStateType, useAppStateSelector } from '../Hooks/useAppState'

const ButtonLoginGoogle = () => {
    const darkMode = useAppStateSelector(AppStateType.APP, 'darkMode')
    return (
        <div>
            <form
                id="gsi-sso"
                method="POST"
                action="https://www.myfreecams.com/php/login.php"
                css={{ colorScheme: 'light' }}
            >
                <input type="hidden" name="submit_login" value="1" />
                <input type="hidden" name="load" value="app" />
                <input
                    type="hidden"
                    id="google_auth_json"
                    name="google_auth_json"
                    value=""
                />
                <div
                    id="g_id_onload"
                    data-client_id="573756009040-069tuma22jeh5mjn4lshq0482uehh890.apps.googleusercontent.com"
                    data-itp_support="false"
                    data-callback="Google_onSignIn"
                />
                <div
                    className="g_id_signin"
                    data-type="standard"
                    data-shape="rectangular"
                    data-text="signin_with"
                    data-size="large"
                    {...(darkMode ? { 'data-theme': 'filled_black' } : {})}
                />
            </form>
        </div>
    )
}

export default ButtonLoginGoogle
